import { render, staticRenderFns } from "./RewardsData.vue?vue&type=template&id=4c484d11&scoped=true"
import script from "./RewardsData.vue?vue&type=script&lang=js"
export * from "./RewardsData.vue?vue&type=script&lang=js"
import style0 from "./RewardsData.vue?vue&type=style&index=0&id=4c484d11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c484d11",
  null
  
)

export default component.exports